export default __webpack_public_path__ + "static/cap3-505e0984691fc2bc7d8df17c16edc367.png";